import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {MatPaginatorIntl, MatPaginatorModule} from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatMenuModule } from '@angular/material/menu';
import { FabBreadcrumbsModule } from '@fabric/components/breadcrumbs';
import { FabHeaderModule } from '@fabric/components/header';
import {
  FabAppInfoModule,
  FabAppLauncherModule,
  FabThemeSettingModule,
  FabUserInfoModule
} from '@fabric/components/header-actions';
import { FabLoadingSpinnerModule } from '@fabric/components/loading-spinner';
import { FabSidenavModule } from '@fabric/components/sidenav';
import { FabTableFilterModule } from '@fabric/components/table-filter';
// @ts-ignore
import { OAuthModule } from 'angular-oauth2-oidc';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CaiMaintenanceComponent } from './components/cai-maintenance/cai-maintenance.component';
import { CreateRemitoComponent } from './components/create-remito/create-remito.component';
import {
  DestinatarioMaintenanceComponent
} from './components/destinatario-maintenance/destinatario-maintenance.component';
import { DockMaintenanceComponent } from './components/dock-maintenance/dock-maintenance.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { ReasonCodeMaintenanceComponent } from './components/reason-code-maintenance/reason-code-maintenance.component';
import {
  SolicitanteMaintenanceComponent
} from './components/solicitante-maintenance/solicitante-maintenance.component';
import { TransporteMaintenanceComponent } from './components/transporte-maintenance/transporte-maintenance.component';
import { UserMaintenanceComponent } from './components/user-maintenance/user-maintenance.component';
import { ViewRemitosComponent } from './components/view-remitos/view-remitos.component';
import { FooterComponent } from './core/footer/footer.component';
import { FunctionValidatorDirective } from './directives/function-validator.directive';
import { AuthenticationService } from './services/authentication.service';
import { SecurityService } from './services/security.service';
import { TokenInterceptorService } from './services/tokeninterceptor.service';
import { CustomdatePipe } from './shared-components/customdate.pipe';
import {getSpanishPaginator} from './shared-components/spanish-paginator';
import {RemDateFilterComponent} from './shared-components/table-filter/date-filter/date-filter.component';
import {
  GenerateRemitosNumberComponent
} from './shared-components/generate-remitos-number/generate-remitos-number.component';
import { NotificationToastComponent } from './shared-components/notification-toast/notification-toast.component';
import { PopupCancelDialogComponent } from './shared-components/popup-cancel-dialog/popup-cancel-dialog.component';
import {
  PopupCancelRemitoDialogComponent
} from './shared-components/popup-cancel-remito-dialog/popup-cancel-remito-dialog.component';
import { PopupDeleteDialogComponent } from './shared-components/popup-delete-dialog/popup-delete-dialog.component';
import { RequiredIndicatorComponent } from './shared-components/required-indicator.component';
import { RequiredMessageComponent } from './shared-components/required-message.component';
import { MgoErrorProcessingComponent } from './components/mgo-error-processing/mgo-error-processing.component';
import { IssuedRemitosReportComponent } from "./components/issued-remitos-report/issued-remitos-report.component";
import { VehicleDestinoTransportistaMaintenanceComponent } from './components/vehicle-destino-transportista-maintenance/vehicle-destino-transportista-maintenance.component';
import { OpenItemsReportComponent } from './components/open-items-report/open-items-report.component';
import {FabMultiselectModule} from "@fabric/components/multiselect";
import {CreateVehicleRemitoComponent} from "./components/create-vehicle-remito/create-vehicle-remito.component";
import {ImpresoraMaintenanceComponent} from "./components/impresora-maintenance/impresora-maintenance.component";
import { TpreMaintenanceComponent } from './components/tpre-maintenance/tpre-maintenance.component';
import {ViewVehicleRemitosComponent} from "./components/view-vehicle-remitos/view-vehicle-remitos.component";
import { PopupCancelVehicleDialogComponent } from './shared-components/popup-cancel-vehicle-dialog/popup-cancel-vehicle-dialog.component';
import { VehicleOnholdReleaseComponent } from './components/vehicle-onhold-release/vehicle-onhold-release.component';
import { PrintEmailRemitosButtonComponent } from './shared-components/print-email-remitos-button/print-email-remitos-button.component';
import {RemNumberFilterComponent} from './shared-components/table-filter/number-filter/number-filter.component';
import {RemStringFilterComponent} from './shared-components/table-filter/string-filter/string-filter.component';
import { VehicleRemitosPrintedComponent } from './components/vehicle-remitos-printed/vehicle-remitos-printed.component';
import { OtdsErrorProcessingComponent } from './components/otds-error-screen/otds-error-processing/otds-error-processing.component';
import { FileUploadComponent } from './shared-components/file-upload/file-upload/file-upload.component';
import { GridResizeDirective } from './directives/grid-resize.directive';
import { OtdsErrorLogComponent } from './components/otds-error-screen/otds-error-log/otds-error-log.component';
import { OtdsErrorRootComponent } from './components/otds-error-screen/otds-error-root/otds-error-root.component';
import { RowDataViewerComponent } from './components/otds-error-screen/row-data-viewer/row-data-viewer.component';
import { PopupFileUploadMessageDialogComponent } from './shared-components/popup-file-upload-message-dialog/popup-file-upload-message-dialog.component';
import { GenericConfirmationDialogComponent } from './shared-components/generic-confirmation-dialog/generic-confirmation-dialog.component';
import { SchedulerStatusComponent } from './components/scheduler-status/scheduler-status.component';

export function initAuth(authenticationService: AuthenticationService,securityService:SecurityService): () => void {
  return () =>
    new Promise<void>((resolve) => {
      authenticationService.initialize().then((isAuthenticated) => {
        if (isAuthenticated) {
          securityService.fetchCurrentUserAsPromise().then((r) => {
            if (r) {
              resolve();
            }
          });
        }
      });
    });
}
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CreateRemitoComponent,
    ViewRemitosComponent,
    UserMaintenanceComponent,
    DockMaintenanceComponent,
    PopupDeleteDialogComponent,
    PopupCancelDialogComponent,
    RequiredIndicatorComponent,
    RequiredMessageComponent,
    ReasonCodeMaintenanceComponent,
    TransporteMaintenanceComponent,
    LoginComponent,
    NotificationToastComponent,
    CustomdatePipe,
    FooterComponent,
    DestinatarioMaintenanceComponent,
    GenerateRemitosNumberComponent,
    SolicitanteMaintenanceComponent,
    FunctionValidatorDirective,
    CaiMaintenanceComponent,
    PopupCancelRemitoDialogComponent,
    VehicleDestinoTransportistaMaintenanceComponent,
    ViewVehicleRemitosComponent,
    IssuedRemitosReportComponent,
    MgoErrorProcessingComponent,
    OpenItemsReportComponent,
    CreateVehicleRemitoComponent,
    OpenItemsReportComponent,
    ImpresoraMaintenanceComponent,
    TpreMaintenanceComponent,
    PopupCancelVehicleDialogComponent,
    VehicleOnholdReleaseComponent,
    PrintEmailRemitosButtonComponent,
    RemDateFilterComponent,
    RemStringFilterComponent,
    RemNumberFilterComponent,
    VehicleRemitosPrintedComponent,
    OtdsErrorProcessingComponent,
    FileUploadComponent,
    GridResizeDirective,
    OtdsErrorLogComponent,
    OtdsErrorRootComponent,
    RowDataViewerComponent,
    PopupFileUploadMessageDialogComponent,
    GenericConfirmationDialogComponent,
    SchedulerStatusComponent,
  ],
  imports: [
    OAuthModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FabBreadcrumbsModule,
    FabAppInfoModule,
    FabAppLauncherModule,
    FabHeaderModule,
    FabSidenavModule,
    FabThemeSettingModule,
    FabUserInfoModule,
    FabLoadingSpinnerModule,
    FabMultiselectModule,
    HttpClientModule,
    MatSnackBarModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDividerModule,
    MatGridListModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatCheckboxModule,
    MatSortModule,
    FabTableFilterModule,
    FlexLayoutModule,
    MatPaginatorModule,
    MatDialogModule,
    FormsModule,
    FabLoadingSpinnerModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatSidenavModule,
    MatTabsModule,
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    AuthenticationService,
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [AuthenticationService,SecurityService],
      multi: true,
    },
    { provide: MatPaginatorIntl, useValue: getSpanishPaginator() }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
